import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type {
	ProductSizeOption,
	StraightenerKpiRow,
} from "../models/StraightenerKpis";

export interface GetStraightenerKpisParams {
	start: string;
	end: string;
	productSizeId: number | null;
	productTypeId: number | null;
	crewId: string | null;
	productionShift: string | null;
	signal?: AbortSignal;
}

export const getStraightenerKpis = async ({
	start,
	end,
	productSizeId,
	productTypeId,
	crewId,
	productionShift,
	signal,
}: GetStraightenerKpisParams): Promise<StraightenerKpiRow[]> => {
	const apiService = new MESApiService();
	// The procedure applies the same inclusive-start/exclusive-end local dates as Runs.
	const parameters: spParameter[] = [
		{ name: "Start", value: start },
		{ name: "End", value: end },
		{ name: "ProductSizeId", value: productSizeId },
		{ name: "ProductTypeId", value: productTypeId },
		{ name: "CrewId", value: crewId },
		{ name: "ProductionShift", value: productionShift },
	];

	const resp = await apiService.callV2(
		"[MILL].[GetStraightenerReport]",
		parameters,
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching straightener KPIs");
	}
	return get(resp, "data.tables[0].rows", []) as StraightenerKpiRow[];
};

export const getStraightenerKpisPickers = async (
	signal?: AbortSignal,
): Promise<ProductSizeOption[]> => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2(
		"[MILL].[GetStraightenerReportPickers]",
		[],
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching product sizes");
	}
	return get(resp, "data.tables[0].rows", []) as ProductSizeOption[];
};
